import PageTitle from "../../components/title/pageTitle";
import Navigation from "../../components/navigation/navigation";
import Footer from "../../components/footer/footer";
import BackHomeIcon from "../../components/icons/BackHome/backhome";
import ResilientImage from "../../components/ResilientImage/ResilientImage";
import { useTranslation } from "../../i18n";
import "./creatorPartnerships.css";

function CreatorPartnerships() {
    const { t } = useTranslation();
    const sections = t("pages.creatorPartnerships.sections") || [];

    return (
        <>
            <PageTitle>
                <Navigation />
            </PageTitle>

            {/*<BackHomeIcon />*/}

            <main className="creator-partnerships">
                <section className="cp-hero">
                    <div className="cp-hero__intro">
                        <h1>{t("nav.creatorPartnerships")}</h1>
                        <p className="cp-eyebrow">{t("pages.creatorPartnerships.heroEyebrow")}</p>
                        <p className="cp-hero__copy">
                            {t("pages.creatorPartnerships.heroIntro")}
                        </p>
                        <p className="cp-hero__copy">{t("pages.creatorPartnerships.heroBody")}</p>
                    </div>
                    <div className="cp-hero__media">
                        <ResilientImage
                            src="https://files.seeusercontent.com/2026/08/31/Bs3d/DSC00293-5-2.jpg"
                            alt={t("pages.creatorPartnerships.sections.0.alt")}
                            className="cp-hero__image"
                            loading="eager"
                            decoding="async"
                        />
                    </div>
                </section>

                {sections.slice(1).map((item, index) => (
                    <section
                        className={`cp-story${index % 2 === 0 ? " cp-story--reverse" : ""}`}
                        key={item.title}
                    >
                        <div className="cp-story__copy">
                            <span className="cp-story__number">
                                {String(index + 2).padStart(2, "0")}
                            </span>
                            <h2>{item.title}</h2>
                            <p>{item.body}</p>
                        </div>
                        <div className="cp-story__media">
                            <ResilientImage
                                src={item.image}
                                alt={item.alt}
                                className="cp-story__image"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                    </section>
                ))}
            </main>

            <Footer />
        </>
    );
}

export default CreatorPartnerships;
